<div fxFill ngxUiLoaderBlurred blur="10">
  <router-outlet></router-outlet>
</div>
